export default __webpack_public_path__ + "static/leung_profile_pic_full-dee21c9afdb2cd4464836f66d3c7bf86.jpg";